import script from "./ViewSpecialApprovalTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSpecialApprovalTypes.vue?vue&type=script&setup=true&lang=js"

import "./ViewSpecialApprovalTypes.vue?vue&type=style&index=0&id=0aa0c606&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa0c606"]])

export default __exports__